export const chowSymbol = (denom) => {
    return denom?.replace(/u/gi, "")?.toUpperCase();
}

export const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str?.charAt(0)?.toUpperCase() + str?.slice(1);
};

export const capitalizeWords = (str) => {
    if (!str) return "";
    return str
        .toLowerCase()
        ?.split(" ")
        ?.map(word => word.charAt(0).toUpperCase() + word.slice(1))
        ?.join(" ");
};